<!-- START: pages/login-beta -->
<div class="cat__pages__login cat__pages__login--fullscreen">
    <div class="cat__pages__login__block cat__pages__login__block--extended">
        <div class="row">
            <div class="col-xl-12">
                <div class="cat__pages__login__block__inner">
                    <div class="cat__pages__login__block__form">
                        <h4 class="">
                            <div class="login-logo"></div>
                            <BR/><br/>

                            <strong *ngIf="isRebrand; then new_prompt else old_prompt">Sign in with your LLS ID </strong>
                            <ng-template #old_prompt><strong>Sign in with your LLS ID </strong></ng-template>
                            <ng-template #new_prompt><strong>Sign in with your current ID </strong></ng-template>

                            <!-- show the environment on login, mainly intended for the mobile app-->
                            <span class="env" *ngIf="hybridToolsService.isMobileApp() && environment">({{environment}})</span>
                        </h4>
                        <br/>

                        <ngb-alert id="loginerror" [hidden]="!errorMessage" type="danger" (close)="errorMessage = null">
                            {{ errorMessage }}
                        </ngb-alert>

                        <form #loginForm="ngForm"
                              (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label class="form-label">Username</label>
                                <input class="form-control"
                                       [(ngModel)]="loginModel.username"
                                       required
                                       placeholder="Email or Username"
                                       name="username"
                                       #username="ngModel">
                                <div class="form-control-error" [hidden]="username.valid || (username.pristine && !loginForm.submitted)">
                                    <ul><li *ngIf="username?.errors?.required">Username is required.</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Password</label>
                                <input class="form-control password"
                                       [(ngModel)]="loginModel.password"
                                       required
                                       name="password"
                                       type="password"
                                       placeholder="Password"
                                       #password="ngModel">
                                <div class="form-control-error" [hidden]="password.valid || (password.pristine && !loginForm.submitted)">
                                    <ul><li *ngIf="password?.errors?.required">Password is required.</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <a (click)="forgotPassword()"
                                   class="pull-right text-primary">Forgot
                                    Password?</a>
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox"
                                               name="example6"
                                               [(ngModel)]="loginModel.rememberMe">
                                        Remember me
                                    </label>
                                </div>
                            </div>
                            <div class="form-actions" style="display: flex;">
                                <button type="submit" class="btn btn-login btn-primary mr-sm-3 mr-1">Sign In</button>
                                <span class="register-link">
                                    No account? <a href="https://bloodcancerunited.org/get-involved/fundraise" target="_blank"
                                                   class="text-primary">Learn more</a> about how you can participate today!
                                </span>
                            </div>
                        </form>
                    </div>
                    <div class="cat__pages__reset__password__form hidden">
                    <h4 class="">
                            <div class="login-logo"></div>
                        </h4>
                        <br/><br/>
                      <form #resetPasswordForm="ngForm" (ngSubmit)="resetPassword()">
                        <div class="form-group">
                        <span>Username or E-mail associated with your account</span>
                        <input [(ngModel)]="resetPasswordModel.email" class="form-control width100"
                                required
                                placeholder="Email or Username"
                                name="Email"
                                pattern="^(['a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                                #Email="ngModel">

                            <div class="form-control-error" [hidden]="Email.valid || (Email.pristine && !resetPasswordForm.submitted)">
                                <ul><li *ngIf="Email?.errors?.required">Email is required.</li></ul>
                                <ul><li *ngIf="Email?.errors?.pattern">Email is invalid.</li></ul>
                            </div>
                        </div>
                        <div class="form-group form-actions no-wrap">
                            <button type="button" (click)="backToLogin()" class="btn btn-outline-primary mr-sm-3 mr-1">
                                        Back to Log-in</button>
                            <button type="submit" class="btn btn-primary mr-sm-3 mr-1">
                                Recover Password</button>
                        </div>
                    </form>
                    <div class="reset-instructions">
                        <p><strong>We'll send you an email to the address above.</strong>
                        If you do not receive it please call us at 888-557-7177.
                        </p>
                    </div>
                    </div>
                    <div class="cat__pages__update__password__form hidden">
                        <form #updatePasswordForm="ngForm" (ngSubmit)="updatePassword()">
                            <span>Please enter your new password:</span> <!-- After "Forgot Password" -->
                            <!--
                            Below the maxlength attribute is 129, but the pattern validation length is 128.
                            This is to avoid having the user paste a 128+ char password, which then gets silently truncated and submitted successfully.
                            In this (unlikely) case, the user would not know that their password has been truncated and wouldn't be able to login.
                            Pattern matches FRT server validation and any changes should be coordinated.
                            -->
                            <div class="form-group">
                                <input [(ngModel)]="updatePasswordModel.password" class="form-control width100"
                                       required
                                       pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!-/:-@\[-`\{-~}€£¥¢])[a-zA-Z0-9!-/:-@\[-`\{-~}€£¥¢]{8,128}$"
                                       maxlength="129"
                                       type="password"
                                       placeholder="New password"
                                       name="Password"
                                       #Password="ngModel">
                                <div class="form-control-error" [hidden]="Password.valid || (Password.pristine && !updatePasswordForm.submitted)">
                                    <ul><li *ngIf="Password?.errors?.required">Required</li></ul>
                                    <ul><li *ngIf="Password?.errors?.pattern">Password should be 8 or more characters with at least 1 number, 1 lowercase letter, 1 uppercase letter, and 1 special character</li></ul>
                                </div>
                            </div>
                            <div class="form-group">
                                <input [(ngModel)]="updatePasswordModel.confirm" class="form-control width100"
                                       type="password"
                                       placeholder="Confirm password"
                                       name="Confirm"
                                       #Confirm="ngModel">
                                <div class="form-control-error" [hidden]="Confirm.valid || (Confirm.pristine && !updatePasswordForm.submitted)">
                                    <ul><li *ngIf="Confirm?.errors?.matchError">Passwords must match!</li></ul>
                                </div>
                            </div>
                            <div class="form-group form-actions no-wrap">
                                <button type="submit" class="btn btn-primary mr-sm-3 mr-1">
                                    Submit Password</button>
                            </div>
                        </form>
                    </div>

                    <div class="cat__pages__use__another mt-2" *ngIf="!hybridToolsService.allowThirdPartyLogin();else thirdPartyLogin">
                        <!-- Hiding text due to apple being apple.  If users are using this link, then we'll direct them to a help screen instead. -->
                        <!-- h4 class="text-black">
                            <strong>Or click <a href="{{ fundraiseUrl }}">here</a> for other sign in options</strong>
                        </h4 -->
                    </div>
                    <ng-template #thirdPartyLogin>
                        <div class="cat__pages__use__another mt-2">
                            <h4 class="text-black"><strong>
                                Or use another service to sign in 
                            </strong></h4>
                            <div class="mt-2">
                                <div (click)="socialLogin('facebook')" class="btn btn-icon ui-facebook-login mr-2" style="display: inline-block; vertical-align: top; padding: 8px 12px!important">
                                    <i class="icmn-facebook"></i>
                                </div>
                                <div *ngIf="hybridToolsService.isMobileApp();else googleWebLogin"(click)="socialLogin('google')" class="btn btn-icon ui-google-login" style="display: inline-block; vertical-align: top; padding: 8px 12px!important">
                                    <i class="icmn-google"></i>
                                </div>
                                <ng-template #googleWebLogin>
                                    <div style="display: inline-block" id="googleSignInContainer">

                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </ng-template>

                    <div class="cat__pages__login__block__sidebar">
                        <h4 *ngIf="!isRebrand" class="cat__pages__login__block__sidebar__title">
                            United in the fight to end cancer.
                        </h4>
                        <div class="cat__pages__login__block__sidebar__item">
                            <p>
                                <strong>Blood Cancer United, formerly LLS,</strong>  is the largest nonprofit dedicated to creating a world without blood cancer. No matter how you support, you'll be part of a growing team of passionate, caring people determined to do more for more people with blood cancer.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cat__pages__login__footer text-center">
        <div class="social-container">
            <h3 class="follow-us">Follow Us</h3>
            <ul class="social-list">
                <li>
                    <a href="https://www.facebook.com/BloodCancerUnited" target="_blank">
                        <img alt="Facebook_BCUnited-01.png" src="https://llsorg.widen.net/content/nfhvdkb4lg/png/Facebook_BCUnited-01.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://instagram.com/bloodcancerunited/" target="_blank">
                        <img alt="Instagram_BCUnited-02.png" src="https://llsorg.widen.net/content/cqunzgpi8d/png/Instagram_BCUnited-02.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://x.com/BloodCancerUtd" target="_blank">
                        <img alt="X-logo_BCUnited-04.png" src="https://llsorg.widen.net/content/f3xcxwaii8/png/X-logo_BCUnited-04.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/company/bloodcancerunited" target="_blank">
                        <img alt="In-logo_BCUnited-05.png" src="https://llsorg.widen.net/content/mbmg3qgsd2/png/In-logo_BCUnited-05.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://www.tiktok.com/@bloodcancerunited" target="_blank">
                        <img alt="tiktok_BCUnited-06.png" src="https://llsorg.widen.net/content/iitvnvpmtf/png/tiktok_BCUnited-06.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://www.youtube.com/@BloodCancerUnited" target="_blank">
                        <img alt="YouTube_BCUnited.png" src="https://llsorg.widen.net/content/f4fiteue2n/png/YouTube_BCUnited.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
                <li>
                    <a href="https://www.threads.com/@bloodcancerunited" target="_blank">
                        <img alt="Threads_BCUnited-03.png" src="https://llsorg.widen.net/content/wvlj6qxrzr/png/Threads_BCUnited-03.png?position=c&quality=80&u=kds6i5&h=35">
                    </a>
                </li>
            </ul>
        </div>
        <div class="text-container">
            <p>The Blood Cancer United mission: Cure blood cancer and improve the quality of life of all patients and their families. Blood Cancer United funds lifesaving blood cancer research around the world, provides free information and support services, and is
                the voice for all blood cancer patients seeking access to quality, affordable, coordinated care.</p>

            <p>Blood Cancer United is a 501(c)(3) organization, and all monetary donations are tax deductible to the fullest extent allowed by tax laws. Please check with your financial advisor if you have more questions. Tax Identification Number: 13-5644916</p>

            <p>© Copyright 2015-2025 Blood Cancer United. A 501(c)(3) organization. All rights reserved.</p>
        </div>
        <div class="image-container">
            <ul class="image-list">
                <li>
                    <a href="https://www.charitynavigator.org/ein/135644916" target="_blank">
                        <img alt="Charity Navigator Four-Star" src="https://llsorg.widen.net/content/3tbwsuhkso/png/footer-logo-charity-navigator-four-star.webp?&amp;quality=80&amp;h=80">
                    </a>
                </li>
                <li>
                    <a href="https://www.guidestar.org/profile/shared/40d84a97-8b7b-4b09-9feb-b93994d2003d" target="_blank">
                        <img style="width:80px;" alt="GuideStar Platinum Transparency 2023" src="https://widgets.guidestar.org/TransparencySeal/6939026">
                    </a>
                </li>
                <li>
                    <img alt="Peer-to-Peer Professional Forum" src="https://llsorg.widen.net/content/r2ay58s2uy/jpeg/P2P%20US%20Top%2030%20Program.webp?&quality=80&h=80">
                </li>
            </ul>
        </div>
        <div class="link-container">
            <ul class="link-list">
                <li>
                    <a href="https://bloodcancerunited.org/about-us/contact-us">Contact us</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/6pgddxcmzw/en-es-privacy-policy" target="_blank">Privacy Policy (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/rsxsfxccn7/en-es-consumer-health-data-privacy-policy" target="_blank">Consumer Health Data Privacy Policy (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/7gnztnbnvs/en-es-security" target="_blank">Security (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/mhdtxtktxm/en-es-copyright-policy" target="_blank">Copyright (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/kq5dqfzzp7/en-es-link-policy" target="_blank">Link Policy (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/ncdrljxzd8/en-es-web-site-terms-of-use" target="_blank">Website terms of use (PDF*)  </a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/hk7mxgqfmt/en-es-financial-transparency-and-independence" target="_blank">Financial transparency and independence (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/2zsmnznq9n/en-es-fundraising-disclosure-policy" target="_blank">Fundraising disclosure (PDF*)</a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/lpnvfl6bxq/en-es-refund-policy" target="_blank">Refund Policy (PDF*) </a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/qwjbzk9cfn/en-es-social-media-community-guidelines" target="_blank">Community guidelines (PDF*) </a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/pttvppkd5r/en-es-accessibility-statement" target="_blank">Accessibility statement (PDF*) </a>
                </li>
                <li>
                    <a href="https://llsorg.widen.net/s/b5pmvqrhmr/en-sweepstakes-rules" target="_blank">Sweepstakes Rules (PDF)</a>
                </li>
                <li>
                    <a href="https://www.bloodcancers.ca/" target="_blank">LLS Canada</a>
                </li>
                <li>
                    <span><sup><i>*Bilingual content/Contenido bilingüe</i></sup></span>
                </li>
            </ul>
        </div>
    </div>
</div>

<!-- IE Message for unsupported Social Login -->
<div class="ie-modal modal" tabindex="-1" role="dialog" style="z-index: 20000; background: #00000075;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Unsupported Browser</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Social Media login is no longer supported on Internet Explorer. Please install another web browser.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

<!-- END: pages/login-beta -->
